import React from 'react';
import BaseApi from '../../../api/BaseApi.js';
import ScreenCaption from '../../screen-caption.js';


export default class PartnerScreen extends React.Component {

    constructor(props) {
        super(props);

        this.state = {currentpartner: {id: null, 
                                        shortname: "", 
                                        name: ""}};

        this.handleChangeName = this.handleChangeName.bind(this);  
        this.handleChangeShortName = this.handleChangeShortName.bind(this); 
        this.save = this.save.bind(this);                         
    }

    async componentDidMount() {

        if (this.props.args.partner && this.props.args.partner.length > 0) {
            BaseApi.get("/project/partner", {headers: {
                'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, params: {id: this.props.args.partner}, withCredentials: true})
            .then(res => { 
                this.setState({currentpartner: res.data})
            })    
            .catch()
        }
    }


    save(event) {
        BaseApi.post('/project/partner', this.state.currentpartner, {headers: {
            'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, withCredentials: true})
        .then(res => {
            var currentpartner = this.state.currentpartner
            currentpartner.id = res.data.id
            this.setState({currentpartner: currentpartner})
            this.props.args.organizatioin = res.data.id
        })
        .catch(error=>console.log(error))
        
        event.preventDefault();
    }

    handleChangeName(event) {
        var currentpartner = this.state.currentpartner
        currentpartner.name = event.target.value
        this.setState({currentpartner: currentpartner})
    }

    handleChangeShortName(event) {
        var currentpartner = this.state.currentpartner
        currentpartner.shortname = event.target.value
        this.setState({currentpartner: currentpartner})
    }

    /*openEvents() {
        this.props.navigate("events", 
        {caller: "program", callargs: this.props.args, programid: this.state.currentProgram.id})

    }

    openProducts() {
        this.props.navigate("products", 
        {caller: "program", callargs: this.props.args, programid: this.state.currentProgram.id})

    }

    openProgramContracts() {
        this.props.navigate("contract-programs", 
        {caller: "program", callargs: this.props.args, programid: this.state.currentProgram.id, caption: "Контракты", program: this.state.currentProgram})

    }

    openRefs() {
        this.props.navigate("refs", 
        {caller: "program", callargs: this.props.args, refrecid: this.state.currentProgram.id})    
    } */

    render() {
        const partnerExists = !!this.state.currentpartner.id;
    
        return (
            <div class="container">
                <ScreenCaption goback={this.props.goback} args={this.props.args} caption={"Организация"}/>
                <div className="row mt-4">
                    <div className="col-lg-8">
                        <div className="card shadow-sm">
                            <div className="card-body">
                                <h6 className="card-title mb-3">
                                    {partnerExists ? "Редактирование организации" : "Новая организация"}
                                </h6>
                                <form>
                                    <div class="form-group">
                                        <label for="shortname"> Краткое наименование:</label>
                                        <input 
                                            type="text" 
                                            class="form-control w-100" 
                                            id="shortname" value={this.state.currentpartner.shortname} 
                                            onChange={this.handleChangeShortName} />
                                        <label for="name">Полное наименование:</label>
                                        <input 
                                            type="text" 
                                            class="form-control w-100" 
                                            id="name"  
                                            value={this.state.currentpartner.name} 
                                            onChange={this.handleChangeName} />
                                        <div className="mt-4 d-flex justify-content-end">
                                            <div class="row mt-3">
                                                <button class="btn btn-primary w-100" onClick={this.save}>Сохранить</button>   
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 mt-4 mt-lg-0">
                        <div className="card shadow-sm">
                            <div className="card-body">
                                <h6 className="card-title mb-3">Действия</h6>
                                {/*
                                {partnerExists && (
                                    <div>
                                        <button 
                                            className="btn btn-outline-primary w-100 mb-2" 
                                            onClick={()=>{this.openEvents()}}>
                                                События
                                        </button>      
                                        <button 
                                            className="btn btn-outline-primary w-100 mb-2"
                                            onClick={()=>{this.openProducts()}}>
                                                Продукты
                                        </button>                             
                                        <button 
                                            className="btn btn-outline-primary w-100 mb-2"
                                            onClick={()=>{this.openProgramContracts()}}>
                                                Контракты
                                        </button>   
                                        <button 
                                             className="btn btn-outline-primary w-100 mb-2"
                                            onClick={()=>{this.openRefs()}}>
                                                Ссылки
                                        </button>   
                            
                                    </div>
                                )}
                                */}    
                                {!partnerExists && (
                                    <p className="text-muted mb-0">
                                    Дополнительные действия станут доступны после сохранения записи.
                                    </p>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
        )
    }

}


// WEBPACK FOOTER //
// ./src/ui/workspace-screens/project/partner.js